import React from 'react';
import {loadModules} from 'esri-loader';
import './locationSearch.scss';
import esriStrings from '../../resources/esriStrings';
import satTrack from '../../resources/satTrack';

const LocationSearch = (props) => {
  const searchRef = React.useRef();
  const [esriSearch, setEsriSearch] = React.useState(null);
  const [showError, setShowError] = React.useState(false);
  const initSearch = async (view) => {
    const [Search, FeatureLayer] = await loadModules([
      'esri/widgets/Search',
      'esri/layers/FeatureLayer'
    ]);
    const sources = [
      {
        layer: new FeatureLayer({
          url: 'https://services1.arcgis.com/G84Qg78md8fRCEAD/arcgis/rest/services/ZipCodes_base/FeatureServer/0',
          outFields: ['*']
        }),
        searchFields: ['ID', 'NAME', 'RG_NAME'],
        displayField: 'ID',
        searchTemplate: '{NAME}, {RG_NAME}, {ID}',
        exactMatch: false,
        outFields: ['*'],
        name: 'Point FS',
        placeholder: esriStrings.searchPlaceHolder,
        maxResults: 6,
        maxSuggestions: 6,
        suggestionsEnabled: true,
        minSuggestCharacters: 0
      }
    ];
    const search = new Search({
      view,
      container: searchRef.current,
      popupEnabled: false,
      resultGraphicEnabled: false,
      sources,
      includeDefaultSources: false
    });
    search.on('search-complete', (evt) => {
      if (evt.numResults < 1) {
        satTrack('location_search', {interface: props.satTitle, success: false, zip_search_term: evt.searchTerm, Description: `${props.satTitle} ZIP Code lookup attempt`});
        setShowError(true);
      } else {
        const zip = evt.results[0].results[0].feature.attributes.ID;
        satTrack('location_search', {interface: props.satTitle, success: true, zip_search_code: zip, zip_search_term: evt.searchTerm, Description: `${props.satTitle} ZIP Code lookup attempt`});
        setShowError(false);
      }
      // console.log(evt);
    });
    search.on('search-clear', () => {
      setShowError(false);
    });
    search.goToOverride = async (view, goToParams) => {
      const $mapPoint = goToParams.target.target.geometry.extent.center;
      props.passSearchPoint(
        $mapPoint,
        props.onValidSearch,
        props.onInvalidSearch
      );
    };
    setEsriSearch(search);
  };

  // React.useEffect(() => {
  //     initSearch();
  // }, []);
  React.useEffect(() => {
    if (props.esriView) {
      initSearch(props.esriView);
    }
  }, [props.esriView]);
  React.useEffect(() => {
    if (esriSearch && props.currentZIP) {
      esriSearch.searchTerm = props.currentZIP;
    }
  }, [props.currentZIP]);

  return (
    <div className={`location-search${showError ? ' show-error' : ''}`}>
      <div ref={searchRef} className="location-search-input"><div className = "search-error">{esriStrings.searchError}</div></div>
    </div>
  );
};

export default LocationSearch;
